module.exports = __webpack_public_path__ + "img/spinning-wheel.347d061.webp";